<template>
  <div class="card card-custom gutter-b" v-if="!loading && detail">
    <div class="card-header d-flex justify-content-between align-items-center">
      <div class="card-title">
        <h3 class="card-label">
          Chi tiết tác vụ thanh tra: {{ headerText }}
        </h3>
        <div class="text-muted small">{{ subHeaderText }}</div>
      </div>
      <div>
        <button v-if="activeTab === 'main' && !isShowMode" class="btn btn-purple-outline mr-2"
          @click="refreshHardDialog = true">
          <i class="fas fa-sync-alt"></i> Làm mới BTVN
        </button>
      </div>
    </div>
    <div class="card-body">
      <el-tabs v-model="activeTab" :class="{ 'tabs-locked': !isShowMode }">
        <el-tab-pane label="Thanh tra bài tập chính" name="main">
          <inspection-section ref="mainSection" :detail="detail" :form.sync="mainForm" :saving="saving"
            @save="onSaveMain" :activeTab="activeTab" :isShowMode="isShowMode"
            :currentSupplementIndex="currentSupplementIndex" :supplementDetailLength="supplementDetail.length"
            @goBack="goBack" @goNext="goNext" :isMainFormDirty="isMainFormDirty" />
        </el-tab-pane>
        <el-tab-pane v-if="supplementDetail.length > 0" label="Thanh tra bài tập bổ sung" name="supplement">
          <div class="supplement-scroll-container">
            <!-- Pagination header for supplement tasks -->
            <div v-if="supplementDetail.length > 1" class="supplement-pagination mb-3">
              <div class="pagination-header">
                <div class="pagination-numbers">
                  <button v-for="(item, index) in supplementDetail" :key="index"
                    :class="['pagination-btn', { 'active': index === currentSupplementIndex }]"
                    @click="isShowMode ? switchSupplementTask(index) : null">
                    {{ index + 1 }}
                  </button>
                </div>
              </div>
            </div>

            <inspection-section ref="supplementSection" :detail="currentSupplementDetail" :form.sync="supplementForm"
              :saving="saving" :activeTab="activeTab" :isShowMode="isShowMode"
              :currentSupplementIndex="currentSupplementIndex" :supplementDetailLength="supplementDetail.length"
              @goBack="goBack" @save="onSaveSupplement" @goNext="goNext" :isSupplementFormDirty="isSupplementFormDirty" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- Làm mới bài tập không có -->
    <no-homework-refresh-dialog :visible.sync="noHomeworkRefreshDialog" @close="noHomeworkRefreshDialog = false" />

    <!-- Bằng tay -->
    <refresh-hard-dialog :visible.sync="refreshHardDialog" :loading="loadingRefreshHard"
      @cancel="refreshHardDialog = false" @confirm="doRefreshHard" />

    <!-- Tự động -->
    <refresh-auto-dialog :visible.sync="refreshAutoDialog" :loading="loadingRefreshHard"
      @cancel="refreshAutoDialog = false" @confirm="doRefresh" />

    <no-replacement-dialog :visible.sync="noReplacementDialog" :disabled="loadingEvaluate"
      @cancel="noReplacementDialog = false" @confirm="confirmSaveNotAllPass" />

    <save-all-pass-dialog :visible.sync="saveAllPassDialog" :disabled="loadingEvaluate"
      @cancel="saveAllPassDialog = false" @confirm="confirmSaveAllPass" />

    <save-need-more-dialog :visible.sync="saveNeedMoreDialog" :loading="loadingsaveNeedMore"
      @cancel="saveNeedMoreDialog = false" @confirm="goToSupplement" />

    <no-homework-more-dialog :visible.sync="noHomeworkMoreDialog" @go-back="supplementDecisionDialog = true" />

    <need-mark-homework-again-dialog :visible.sync="needMarkHomeworkAgainDialog" :detail="detail" @later="markLater"
      @now="markNow" />

    <supplement-decision-dialog :visible.sync="supplementDecisionDialog" :option.sync="supplementDecisionOption"
      :classificationType.sync="classificationType" :decisionError="decisionError"
      :classificationError="classificationError" :loading="loadingsupplementDecision"
      @cancel="supplementDecisionDialog = false" @change="onDecisionChange" @confirm="onConfirmSupplementDecision" />
  </div>
  <inspection-task-detail-skeleton v-else />
</template>

<script>
import {
  INSPECTION_DETAIL, INSPECTION_UPDATE, INSPECTION_SUPPLEMENT_CANDIDATE, INSPECTION_SAVE_EVALUATE,
  CREATE_ERROR_INSPECTION, DELETE_SIMILAR_TASK
} from '@/core/services/store/inspection/inspection.module';
import {
  InspectionSection, InspectionTaskDetailSkeleton, NoHomeworkRefreshDialog, RefreshHardDialog, RefreshAutoDialog, NoReplacementDialog,
  SaveAllPassDialog, SaveNeedMoreDialog, NoHomeworkMoreDialog, NeedMarkHomeworkAgainDialog, SupplementDecisionDialog,
} from './components/inspection-detail';
const defaultCriteria = () => ({ value: '', note: '' });
const defaultForm = () => ({
  ta: { right: defaultCriteria(), fix: defaultCriteria() },
  cc: { right: defaultCriteria(), fix: defaultCriteria() },
  lr: { right: defaultCriteria(), fix: defaultCriteria() },
  gra: { right: defaultCriteria(), fix: defaultCriteria() },
});


import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";

export default {
  name: 'InspectionTaskDetail',
  components: {
    InspectionSection, InspectionTaskDetailSkeleton, NoHomeworkRefreshDialog, RefreshHardDialog, RefreshAutoDialog, NoReplacementDialog,
    SaveAllPassDialog, SaveNeedMoreDialog, NoHomeworkMoreDialog, NeedMarkHomeworkAgainDialog, SupplementDecisionDialog,
  },
  data() {
    return {
      id: this.$route.params.id,
      detail: null,
      supplementDetail: [],
      currentSupplementIndex: 0,
      mainForm: defaultForm(),
      supplementForm: defaultForm(),
      activeTab: 'main',
      noReplacementDialog: false,
      saveAllPassDialog: false,
      saveNeedMoreDialog: false,
      supplementDecisionDialog: false,
      supplementDecisionOption: '',
      classificationType: '',
      decisionError: '',
      classificationError: '',
      saving: false,
      loading: false,
      loadingEvaluate: false,
      evaluationPayload: null,
      except: [],
      noHomeworkMoreDialog: false,
      needMarkHomeworkAgainDialog: false,
      noHomeworkRefreshDialog: false,
      refreshHardDialog: false,
      refreshAutoDialog: false,
      loadingRefreshHard: false,
      loadingsupplementDecision: false,
      loadingsaveNeedMore: false,
      // Dirty state tracking
      originalMainForm: null,
      originalSupplementForm: null,
      isMainFormDirty: false,
      isSupplementFormDirty: false,
    };
  },
  computed: {
    isShowMode() {
      return this.$route.query.mode === 'show';
    },
    isEditMode() {
      return !this.isShowMode;
    },
    headerText() {
      if (!this.detail) return '...';
      return `Giảng viên ${this.detail.teacher_name} - Khóa ${this.detail.course_name} / ${this.detail.student_name} / Buổi ${this.detail.lesson_id}
      / Câu ${this.detail.sentence}`;
    },
    subHeaderText() {
      return this.activeTab === 'main' ? 'Thanh tra bài tập chính' : 'Thanh tra bài tập bổ sung';
    },
    currentSupplementDetail() {
      if (this.supplementDetail.length > 0 && this.currentSupplementIndex < this.supplementDetail.length) {
        return this.supplementDetail[this.currentSupplementIndex];
      }
      return null;
    },
  },
  watch: {
    // Watch for changes in main form
    mainForm: {
      handler() {
        this.updateMainFormDirtyState();
      },
      deep: true
    },
    // Watch for changes in supplement form
    supplementForm: {
      handler() {
        this.updateSupplementFormDirtyState();
      },
      deep: true
    }
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Quản trị chất lượng", route: "" },
      { title: "Thanh tra chấm BTVN", route: "" },
      { title: "Chi tiết tác vụ thanh tra", route: "" }
    ]);
    await this.fetchDetail();
    if (this.detail.type_inspection == 1 && this.isEditMode) {
      await this.checkRefreshOnEnter();
    }
    this.loading = false;
  },
  methods: {
    markLater() {
      this.needMarkHomeworkAgainDialog = false;
      this.redirectToInspectionHomeworkPersonal();
    },
    markNow() {
      this.needMarkHomeworkAgainDialog = false;
      this.goToMarkHomework();
    },
    setActiveTab(tabName) {
      this.activeTab = tabName;

      // Reset dirty state when switching back to main tab
      if (tabName === 'main' && this.isEditMode) {
        this.$nextTick(() => {
          this.originalMainForm = this.cloneForm(this.mainForm);
          this.isMainFormDirty = false;
        });
      }
    },
    async callApiGetList(id) {
      try {
        const response = await this.$store.dispatch(INSPECTION_DETAIL, id);
        this.loading = false;
        this.detail = response.data;
        // Set supplementDetail as array from API response
        this.supplementDetail = response.data.children || [];
        // Keep current index if valid, otherwise reset to 0
        if (this.currentSupplementIndex >= this.supplementDetail.length) {
          this.currentSupplementIndex = Math.max(0, this.supplementDetail.length - 1);
        }

        // Auto-fill evaluations and handle tab switching
        await this.handleAutoFillAndTabSwitching();

        return response;
      } catch (e) {
        this.loading = false;
        throw e;
      }
    },
    async fetchDetail(taskId) {
      const id = taskId || this.id;
      return this.callApiGetList(id)
    },
    async checkRefreshOnEnter() {
      // If graded_at older than 7 days from now -> ask refresh
      const time_mark = new Date(this.detail.updated_at_overall);
      const time_inspect = new Date(this.detail.created_at_inspection);
      const diffDays = Math.floor((time_inspect.getTime() - time_mark.getTime()) / (24 * 60 * 60 * 1000));
      if (diffDays > 7) {
        this.refreshAutoDialog = true;
      }
    },
    async doRefreshHard() {
      this.doRefresh()
    },
    async doRefresh() {
      this.loadingRefreshHard = true;
      await this.$store.dispatch(INSPECTION_SUPPLEMENT_CANDIDATE, { id: this.id }).then(response => {
        if (response.data) {
          this.detail = response.data;
          this.$message.success('Đã làm mới BTVN sang bài gần nhất');
        } else {
          this.noHomeworkRefreshDialog = true;
        }
      }).catch(error => {
        return null;
      }).finally(() => {
        this.loadingRefreshHard = false;
        this.refreshHardDialog = false;
        this.refreshAutoDialog = false;
      });
    },
    onRefreshClick() { this.doRefresh(); },
    async onSaveMain() {
      // evaluate mainForm: if all values are '1' then show all-pass dialog, else need-more dialog
      const allValues = [];
      const push = (o) => { allValues.push(o.right.value, o.fix.value); };
      push(this.mainForm.ta); push(this.mainForm.cc); push(this.mainForm.lr); push(this.mainForm.gra);
      const allPass = allValues.every((v) => v == '1');

      // Store evaluation payload for later use
      this.evaluationPayload = this.buildEvaluatePayload(this.mainForm, this.id);

      if (allPass) {
        this.saveAllPassDialog = true;
        return;
      }
      // else
      this.saveNeedMoreDialog = true;
    },
    async postEvaluateFailNow() {
      this.loadingEvaluate = true;
      await this.updateInspectionMain();
      this.loadingEvaluate = false;
    },
    async postEvaluateSuccessNow() {
      this.loadingEvaluate = true;
      await this.updateInspectionMain();
      this.loadingEvaluate = false;
      this.redirectToInspectionHomeworkPersonal();
      this.$notify.success({
        title: 'Hoàn thành',
        message: `Thanh tra chất lượng chấm bài tập ${this.detail.course_name} - buổi ${this.detail.lesson_id} - câu ${this.detail.sentence}`,
        offset: 100
      })
    },
    async updateInspection(payload) {
      try {
        const response = await this.$store.dispatch(INSPECTION_SAVE_EVALUATE, payload);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async updateInspectionMain() {
      const payload = this.buildEvaluatePayload(this.mainForm, this.id);
      this.updateInspection(payload)
    },
    async updateInspectionSupplement() {
      const payload = this.buildEvaluatePayload(this.supplementForm, this.currentSupplementDetail.inspection_task_id);
      this.updateInspection(payload)
    },
    async changeStatusAndResult(status, result) {
      try {
        const payload = {
          id: this.id,
          ...(status ? { status } : {}),
          ...(result ? { result } : {})
        };
        const response = await this.$store.dispatch(INSPECTION_UPDATE, payload);
        return response;
      } catch (error) {
        this.$message.error('Có lỗi xảy ra!');
        throw error;
      }
    },
    async createError(type) {
      try {
        const response = await this.$store.dispatch(CREATE_ERROR_INSPECTION, {
          test_overall_id: this.detail.overall_result_id,
          id: this.id,
          type: type
        });
        return response;
      } catch (error) {
        this.$message.error('Có lỗi xảy ra!');
        throw error;
      }
    },

    async confirmSaveAllPass() {
      await this.changeStatusAndResult(2, 1);
      await this.postEvaluateSuccessNow();
      this.saveAllPassDialog = false;
    },
    async confirmSaveNotAllPass() {
      await this.changeStatusAndResult(1, 2);
      await this.createError(1);
      await this.postEvaluateFailNow();
      this.saveNeedMoreDialog = false;
      this.noReplacementDialog = false;
      this.needMarkHomeworkAgainDialog = true;
      // this.goToMarkHomework();
    },
    async goToSupplement() {
      await this.changeStatusAndResult(null, 2);
      await this.updateInspectionMain();
      let currentIndex = this.activeTab === 'main' ? 0 : this.currentSupplementIndex + 1;
      await this.removeSupplementTasks(currentIndex);
      try {
        const sec = this.$refs.mainSection;
        if (sec && sec.$refs && sec.$refs.evaluate && sec.$refs.evaluate.resetValidation) {
          sec.$refs.evaluate.resetValidation();
        }
      } catch (e) { /* noop */ }

      this.loadingsaveNeedMore = true;
      let payload = {
        id: this.id,
        similar: true
      }

      // Add each except item as a separate 'except[]' parameter
      this.except.forEach(item => {
        payload['except[]'] = item;
      });

      await this.$store.dispatch(INSPECTION_SUPPLEMENT_CANDIDATE, payload).then(async response => {
        if (response.data) {
          this.except = [...this.except, response.data.id];
          this.setActiveTab('supplement');
          // Clear supplement form when loading new supplement data
          this.supplementForm = defaultForm();
          // Refresh data by calling API again to get updated supplementDetail array
          await this.callApiGetList(this.id);
          // Set current index to the last item (newly added)
          this.currentSupplementIndex = this.supplementDetail.length - 1;

          // Auto-fill evaluation for the new supplement task if it exists
          const currentSupplement = this.currentSupplementDetail;
          if (currentSupplement && currentSupplement.evaluation_of_scorings) {
            this.fillEvaluationForm(currentSupplement, this.supplementForm);
          }

          this.saveNeedMoreDialog = false;
          // After switching tab, reset supplement validation errors
          this.$nextTick(() => {
            try {
              const sec2 = this.$refs.supplementSection;
              if (sec2 && sec2.$refs && sec2.$refs.evaluate && sec2.$refs.evaluate.resetValidation) {
                sec2.$refs.evaluate.resetValidation();
              }
            } catch (e) { /* noop */ }
          });
        } else {
          if (this.except.length == 0) {
            this.noReplacementDialog = true;
            this.saveNeedMoreDialog = false;
          } else {
            this.noHomeworkMoreDialog = true;
          }
        }

      }).catch(error => {
        this.$message.error('Có lỗi xảy ra!');
      });
      this.loadingsaveNeedMore = false;
      this.loadingsupplementDecision = false;
    },
    async onSaveSupplement() {
      this.supplementDecisionDialog = true;
    },
    onDecisionChange() {
      this.decisionError = '';
      // reset classification when switching away
      if (this.supplementDecisionOption !== 'classify') {
        this.classificationType = '';
        this.classificationError = '';
      }
    },
    async onConfirmSupplementDecision() {
      this.loadingsupplementDecision = true;
      this.decisionError = '';
      this.classificationError = '';
      const choice = this.supplementDecisionOption;
      // Validate choice
      if (!choice) {
        this.decisionError = 'Vui lòng chọn một phương án trước khi xác nhận.';
        this.loadingsupplementDecision = false;
        return;
      }
      // Validate classification when needed
      if (choice === 'classify' && !this.classificationType) {
        this.classificationError = 'Vui lòng chọn phân loại lỗi cho bài tập này.';
        this.loadingsupplementDecision = false;
        return;
      }

      // save post valuate
      await this.updateInspectionSupplement();

      if (choice === 'continue') {
        this.supplementDecisionDialog = false;
        this.goToSupplement();
      } else if (choice === 'classify') {
        await this.changeStatusAndResult(1);
        if (this.classificationType == 'incident') {
          await this.createError(1);
        } else if (this.classificationType == 'system') {
          await this.createError(2);
        }
        this.loadingsupplementDecision = false;
        this.supplementDecisionDialog = false;
        this.needMarkHomeworkAgainDialog = true;
      }
      this.supplementDecisionOption = '';
      this.classificationType = '';
    },
    buildEvaluatePayload(form, id) {
      return {
        inspection_task_id: id,
        evaluation_detail: JSON.stringify(form)
      };
    },
    goBack() {
      // Navigate to previous task in sequence
      if (this.activeTab === 'supplement') {
        if (this.currentSupplementIndex > 0) {
          // Go to previous supplement page
          this.switchSupplementTask(this.currentSupplementIndex - 1);
        } else {
          // Go back to main task (first supplement page → main)
          this.setActiveTab('main');
        }
      }
    },
    switchSupplementTask(index) {
      if (index >= 0 && index < this.supplementDetail.length) {
        this.currentSupplementIndex = index;

        if (this.isEditMode) {
          // Reset form when switching to different supplement task in edit mode
          this.supplementForm = defaultForm();
        }

        // Auto-fill evaluation for the selected supplement task
        this.fillEvaluationForm(this.currentSupplementDetail, this.supplementForm);

        // Reset dirty state for supplement form after switching
        this.$nextTick(() => {
          this.originalSupplementForm = this.cloneForm(this.supplementForm);
          this.isSupplementFormDirty = false;
        });

        if (this.isEditMode) {
          // Reset validation errors only in edit mode
          this.$nextTick(() => {
            try {
              const sec = this.$refs.supplementSection;
              if (sec && sec.$refs && sec.$refs.evaluate && sec.$refs.evaluate.resetValidation) {
                sec.$refs.evaluate.resetValidation();
              }
            } catch (e) { /* noop */ }
          });
        }
      }
    },
    async goNext() {
      // Navigate to next task in sequence
      if (this.activeTab === 'main') {
        if (this.supplementDetail.length > 0) {
          // Go to first supplement page
          this.setActiveTab('supplement');
          this.switchSupplementTask(0);
        }
      } else if (this.activeTab === 'supplement') {
        if (this.currentSupplementIndex < this.supplementDetail.length - 1) {
          // Go to next supplement page
          this.switchSupplementTask(this.currentSupplementIndex + 1);
        }
      }
    },
    async handleAutoFillAndTabSwitching() {
      // Handle main task evaluation auto-fill
      if (this.detail && this.detail.evaluation_of_scorings) {
        this.fillEvaluationForm(this.detail, this.mainForm);
      }

      // Handle supplement tasks logic
      if (this.supplementDetail.length > 0) {
        if (this.isShowMode) {
          // Show mode: always start with Main tab
          this.currentSupplementIndex = 0;
          this.setActiveTab('main');
        } else {
          // Edit mode: Set currentSupplementIndex to the last supplement task and switch to supplement tab
          this.currentSupplementIndex = this.supplementDetail.length - 1;

          // Switch to supplement tab only if we're currently on main tab
          if (this.activeTab === 'main') {
            await this.$nextTick();
            this.setActiveTab('supplement');
          }
        }

        // Fill evaluation for current supplement task if it has evaluation
        const currentSupplement = this.currentSupplementDetail;
        if (currentSupplement && currentSupplement.evaluation_of_scorings) {
          this.fillEvaluationForm(currentSupplement, this.supplementForm);
        }
      }

      // Initialize original forms for dirty state tracking after all forms are filled
      await this.$nextTick();
      this.initializeOriginalForms();
    },
    fillEvaluationForm(taskData, formObject) {
      if (!taskData?.evaluation_of_scorings) return;

      try {
        const evaluation = taskData.evaluation_of_scorings;

        // Parse evaluation_detail - handle double-encoded JSON
        let formData = evaluation.evaluation_detail;
        if (typeof formData === 'string') {
          formData = JSON.parse(formData);
          // Parse again if still string (double-encoded)
          if (typeof formData === 'string') {
            formData = JSON.parse(formData);
          }
        }

        if (formData && typeof formData === 'object') {
          Object.keys(formData).forEach(key => {
            if (formObject[key] && formData[key]) {
              // Update reactive object properties
              if (formData[key].right) {
                formObject[key].right.value = formData[key].right.value;
                formObject[key].right.note = formData[key].right.note;
              }
              if (formData[key].fix) {
                formObject[key].fix.value = formData[key].fix.value;
                formObject[key].fix.note = formData[key].fix.note;
              }
            }
          });
        }
      } catch (e) {
      }
    },
    // Deep clone form data for dirty state tracking
    cloneForm(formData) {
      return JSON.parse(JSON.stringify(formData));
    },
    // Initialize original form states for dirty tracking
    initializeOriginalForms() {
      this.originalMainForm = this.cloneForm(this.mainForm);
      this.originalSupplementForm = this.cloneForm(this.supplementForm);
      this.isMainFormDirty = false;
      this.isSupplementFormDirty = false;
    },
    // Check if form has been modified
    checkFormDirty(currentForm, originalForm) {
      return JSON.stringify(currentForm) !== JSON.stringify(originalForm);
    },
    // Update dirty state for main form
    updateMainFormDirtyState() {
      if (this.originalMainForm) {
        this.isMainFormDirty = this.checkFormDirty(this.mainForm, this.originalMainForm);
      }
    },
    // Update dirty state for supplement form
    updateSupplementFormDirtyState() {
      if (this.originalSupplementForm) {
        this.isSupplementFormDirty = this.checkFormDirty(this.supplementForm, this.originalSupplementForm);
      }
    },
    // Remove supplement tasks starting from given index
    async removeSupplementTasks(fromIndex = 0) {
      if (this.supplementDetail.length === 0) return;

      const idsToRemove = this.supplementDetail
        .slice(fromIndex)
        .map(item => item.inspection_task_id)
        .filter(id => id); // Filter out any undefined/null ids

      if (idsToRemove.length === 0) return;

      try {
        await this.$store.dispatch(DELETE_SIMILAR_TASK, { ids: idsToRemove });
        this.except = [];
        // Refresh data after removal
        await this.fetchDetail();

        // Navigate to appropriate tab
        if (this.supplementDetail.length === 0) {
          // No supplements left, go to main tab
          this.setActiveTab('main');
        } else {
          // Adjust current index if needed
          if (this.currentSupplementIndex >= this.supplementDetail.length) {
            this.currentSupplementIndex = Math.max(0, this.supplementDetail.length - 1);
          }
        }
      } catch (error) {
        this.$message.error('Có lỗi xảy ra khi xóa bài tập bổ sung');
      }
    },
    goToMarkHomework() {
      this.$router.push({
        name: "mark-homework-v2", params: { id: this.detail.classroom_id },
        query: {
          classroom_id: this.detail.classroom_id, lesson: this.detail.lesson_id,
          student_id: this.detail.user_id, overall_id: this.detail.overall_result_id,
          typeReMark: 'remark-inspection',
          inspection_id: this.id,
          order: this.detail.order,
          learning_schedule_id: this.detail.learning_schedule_id,
        }
      });
    },
    redirectToInspectionHomeworkPersonal() {
      this.$router.push({ name: 'inspection-homework-personal', query: this.$route.query });
    },
  },
};
</script>

<style scoped lang="scss" src="./InspectionTaskDetail.scss"></style>
